import React from 'react';
import { Sparkles, X } from 'lucide-react';

const PromoBar = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div
      data-testid="promo-bar"
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-[#c9a961] via-[#d4af37] to-[#c9a961] shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center relative">
        <div className="flex items-center space-x-3 text-black pr-8 md:pr-0">
          <Sparkles size={20} className="animate-pulse flex-shrink-0" />
          <span className="font-semibold text-sm md:text-base">
            New Clients Get 15% Off - Use Code: <span className="font-bold tracking-wider">PREP15</span>
          </span>
          <button
            data-testid="promo-book-cta"
            onClick={() => window.open('https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh', '_blank')}
            className="hidden md:inline-block ml-4 px-4 py-1.5 bg-black text-[#c9a961] font-semibold text-sm hover:bg-black/90 transition-all duration-300 hover:scale-105"
          >
            Book Now →
          </button>
        </div>

        {/* Close button */}
        <button
          data-testid="promo-close"
          onClick={onClose}
          className="absolute right-4 text-black/70 hover:text-black transition-colors p-1"
          aria-label="Close promo banner"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default PromoBar;
